import React, { useEffect } from 'react'
import { useStyles } from './styles'
import {
  Typography,
  Select,
  MenuItem,
  Button,
  TextField
} from '@mui/material'
import { useColorBtn } from './hooks/useColorBtn'
import { TypeBtn } from './types/typeBtn'
import { useZones } from '../../../../hooks'
import { usePickingReport } from '../../Context/usePickingReport'
import { PickingReportBusiness } from '../../actions/PickingReportBusiness'

export const PickingReportSearch = () => {
  const classes = useStyles()
  const { handleChangeColor, handleChangeType, btnType } = useColorBtn()
  const { state } = usePickingReport()
  const { handleSelectZone, handleChangeFilteredDate, getSearch } =
    PickingReportBusiness()

  const {
    zonesState: { zones },
    getZones
  } = useZones()

  useEffect(() => {
    if (zones?.length === 0) {
      getZones()
    }
  }, [])

  useEffect(() => {
    if (btnType !== 1) {
      getSearch()
    }
  }, [state.selectedZone, state.btnType])

  return (
    <div className={classes.container}>
      <div>
        <Typography variant='h6' component='h6'>
          Escoja la zona por la cual desea filtrar:
        </Typography>

        <div className={classes.selectContainer}>
          <Select
            variant='outlined'
            value={state.selectedZone}
            onChange={(e) => handleSelectZone(Number(e.target.value))}
            fullWidth
          >
            <MenuItem value={0}>Todas</MenuItem>
            {zones?.map((zone) => (
              <MenuItem key={zone.zoneName} value={zone.zoneId}>
                {zone.zoneName}
              </MenuItem>
            ))}
          </Select>
        </div>

        <Typography variant='h6' component='h6'>
          ¿Qué OTs desea visualizar?
        </Typography>

        <div className={classes.buttonsContainer}>
          <Button
            variant='contained'
            color={handleChangeColor(TypeBtn.CurrentDate)}
            onClick={() => handleChangeType(TypeBtn.CurrentDate)}
          >
            Fecha de entrega hoy
          </Button>
          <Button
            variant='contained'
            color={handleChangeColor(TypeBtn.Pending)}
            onClick={() => handleChangeType(TypeBtn.Pending)}
          >
            Pendientes
          </Button>
          <Button
            variant='contained'
            color={handleChangeColor(TypeBtn.OtherDate)}
            onClick={() => handleChangeType(TypeBtn.OtherDate)}
          >
            Definir fecha
          </Button>
          {btnType === TypeBtn.OtherDate && (
            <React.Fragment>
              <div className={classes.dateContainer}>
                <TextField
                  value={state.filteredDate}
                  variant='outlined'
                  label='Fecha'
                  type='date'
                  fullWidth
                  InputLabelProps={{
                    shrink: true
                  }}
                  onChange={(e) => handleChangeFilteredDate(e)}
                  helperText={
                    state.filteredDate.length == 0
                      ? 'Debe ingresar una fecha válida'
                      : ''
                  }
                  error={state.filteredDate.length == 0}
                />
              </div>

              <Button
                onClick={getSearch}
                variant='contained'
                color='primary'
                style={{ height: '45px', marginLeft: '10px' }}
                disabled={state.filteredDate.length == 0}
              >
                Buscar
              </Button>
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  )
}
